/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Pagination_No_ResultsInputs */

const es_settings_files_pagination_no_results = /** @type {(inputs: Settings_Files_Pagination_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin resultados`)
};

const en_settings_files_pagination_no_results = /** @type {(inputs: Settings_Files_Pagination_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results`)
};

/**
* | output |
* | --- |
* | "No results" |
*
* @param {Settings_Files_Pagination_No_ResultsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_pagination_no_results = /** @type {((inputs?: Settings_Files_Pagination_No_ResultsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Pagination_No_ResultsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_pagination_no_results(inputs)
	return en_settings_files_pagination_no_results(inputs)
});
export { settings_files_pagination_no_results as "settings.files.pagination.no_results" }